import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconXClose from "../../../../img/icons/x-close.svg";

interface IProps {
    closeButtonRef: (elem: HTMLButtonElement | null) => void;
    onCloseButtonClick: () => void;
    prefixNameCapped: string;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to 34 LOC, simple presentational component with button ref and onClick handler, minimal props, no state or lifecycle.
export class ConfiguratorPanelHeadAlternative extends React.PureComponent<
    IProps,
    IState
> {
    render() {
        return (
            <div className="configurator__panel--head">
                <h5>{this.props.prefixNameCapped}</h5>
                <button
                    ref={this.props.closeButtonRef}
                    aria-label={t`Close`}
                    onClick={this.props.onCloseButtonClick}
                >
                    <SVG aria-hidden="true" src={iconXClose} />
                </button>
            </div>
        );
    }
}
